import React from 'react'
import { AppContext } from '../../context'

function toDegreesDecimalMinutes(coordinate: number) {
  var absolute = Math.abs(coordinate)
  var degrees = Math.floor(absolute)
  var minutesNotTruncated = (absolute - degrees) * 60
  var roundedMinutesString = minutesNotTruncated.toFixed(2)
  var splitMinutes = roundedMinutesString.split('.')
  var minutes = Math.floor(minutesNotTruncated)
  var decimal = splitMinutes[1]

  return degrees + '° ' + minutes + '´·' + decimal
}

interface Props {
  position: {
    lat: number
    lng: number
  }
}

const InfoControl: React.FC<Props> = ({ position }) => {
  const { lat, lng } = position
  // sourced from https://stackoverflow.com/questions/37893131/how-to-convert-lat-long-from-decimal-degrees-to-dms-format/37893239
  var latitude = toDegreesDecimalMinutes(lat)
  var longitude = toDegreesDecimalMinutes(lng)

  return (
    <AppContext.Consumer>
      {({ activePopover, onTogglePopover }) => (
        <div className="mapboxgl-ctrl imray-infobar">
          <div className="imray-infobar-field">
            POS (CURSOR)
            <div className="imray-infobar-field-value">
              {latitude}{' '}
              <span className="lat-direction">{lat >= 0 ? 'N' : 'S'}</span>{' '}
              {longitude}{' '}
              <span className="lat-direction">{lng >= 0 ? 'E' : 'W'}</span>
            </div>
          </div>
        </div>
      )}
    </AppContext.Consumer>
  )
}

export default InfoControl
